import { Link } from "react-router-dom";
import { Linkedin, Twitter, Facebook } from "lucide-react";
import { Logo, LogoFull } from "./Logo";
import { useLang } from "../i18n";
import { useLenis } from "./SmoothScroll";
import { scrollToId } from "./Header";

export const Footer = () => {
  const { t } = useLang();
  const lenisRef = useLenis();

  const links = [
    { id: "accueil", label: t.nav.home },
    { id: "apropos", label: t.nav.about },
    { id: "produits", label: t.nav.products },
    { id: "logistique", label: t.nav.trade },
    { id: "contact", label: t.nav.contact },
  ];

  const socials = [
    { icon: Linkedin, label: "LinkedIn", testId: "social-linkedin" },
    { icon: Twitter, label: "X / Twitter", testId: "social-twitter" },
    { icon: Facebook, label: "Facebook", testId: "social-facebook" },
  ];

  return (
    <footer data-testid="site-footer" className="grain relative bg-oris-deep text-oris-cream">
      <div className="relative mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <LogoFull className="w-52" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-oris-cream/60">{t.footer.tagline}</p>
            <div className="mt-8 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  data-testid={s.testId}
                  onClick={(e) => e.preventDefault()}
                  className="flex h-10 w-10 items-center justify-center border border-oris-cream/20 text-oris-cream/70 transition-colors duration-300 hover:border-oris-gold hover:text-oris-gold"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="mb-6 text-[0.68rem] font-bold uppercase tracking-[0.24em] text-oris-gold">{t.footer.navTitle}</h4>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(lenisRef, l.id)}
                    className="text-sm text-oris-cream/70 transition-colors duration-300 hover:text-oris-gold"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="mb-6 text-[0.68rem] font-bold uppercase tracking-[0.24em] text-oris-gold">{t.footer.legalTitle}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/mentions-legales"
                  data-testid="footer-link-legal"
                  className="text-sm text-oris-cream/70 transition-colors duration-300 hover:text-oris-gold"
                >
                  {t.footer.legal[0]}
                </Link>
              </li>
              <li>
                <Link
                  to="/politique-confidentialite"
                  data-testid="footer-link-privacy"
                  className="text-sm text-oris-cream/70 transition-colors duration-300 hover:text-oris-gold"
                >
                  {t.footer.legal[1]}
                </Link>
              </li>
              <li>
                <Link
                  to="/admin"
                  data-testid="footer-admin-link"
                  className="text-sm text-oris-cream/70 transition-colors duration-300 hover:text-oris-gold"
                >
                  {t.footer.admin}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-oris-cream/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs tracking-wide text-oris-cream/45">{t.footer.rights}</p>
          <p className="font-serif text-sm italic text-oris-gold/70">Abidjan — Rotterdam — Hô Chi Minh — New York</p>
        </div>
      </div>
    </footer>
  );
};
